import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import styled from 'styled-components';
import VizExCheckbox from 'visitor-ui-component-library/input/VizExCheckbox';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import { jsx as _jsx } from "react/jsx-runtime";
const BreakString = styled.div.withConfig({
  displayName: "ConsentCheckbox__BreakString",
  componentId: "sc-1vhm0ji-0"
})(["-ms-word-break:break-all;display:block;word-break:break-word;word-wrap:break-word;"]);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentCheckbox__SmallNoParagraphPadding",
  componentId: "sc-1vhm0ji-1"
})(["p{margin-bottom:0;}"]);
const ConsentCheckbox = ({
  message,
  isChecked,
  onChange
}) => {
  const cleanMessage = formatHtml(message);
  return /*#__PURE__*/_jsx(VizExCheckbox, {
    checked: isChecked,
    onChange: onChange,
    children: /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      children: /*#__PURE__*/_jsx(BreakString, {
        children: /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: cleanMessage
          }
        })
      })
    })
  });
};
ConsentCheckbox.displayName = 'ConsentCheckbox';
export default ConsentCheckbox;